export class Coords {
  id;
  lat;
  lng;
  // Latitude: 51.9189 Longitude: 19.1344 -- POLAND COORDS
  constructor(lat = 51.9189, lng = 19.1344) {
    this.lat = lat;
    this.lng = lng;
  }
}
